/*
 * @Author: Roman
 * @Date: 2022-11-08 13:54:28
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2022-11-08 14:47:02
 * @FilePath: \qpmn-site\src\app\modules\product-catalog\model\dto\MaximumPriceSort.ts
 * @Description: 
 */
import { PageSort } from "@modules/main/model/dto/sort/PageSort";


export class MaximumPriceSort extends PageSort {

    public property: string = "lowestPrice";

    public direction: string = "DESC";
}